export default __webpack_public_path__ + "static/media/FlexShopper-300w-min.aece7fe3.jpeg";